import { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import logo from "../assets/logo_negro.png";

export function QrDevice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!show) return undefined;
    const timer = window.setTimeout(() => setShow(false), 5000);
    return () => window.clearTimeout(timer);
  }, [show]);

  return (
    <div className="flex flex-col items-center">
      <div className="relative flex items-center justify-center border border-neutral-200 bg-white p-3">
        <QRCodeCanvas
          value={JSON.stringify({
            token: localStorage.getItem("token"),
            shop_id: localStorage.getItem("shop_id"),
            exercise_id: localStorage.getItem("exercise_id"),
          })}
          size={176}
          imageSettings={{ src: logo, height: 28, width: 28, excavate: true }}
        />
        {!show && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/95 p-4">
            <Button
              type="button"
              onClick={() => setShow(true)}
              className="h-12 px-5"
            >
              Mostrar QR
            </Button>
          </div>
        )}
      </div>
      <p className="mt-3 text-center text-sm text-neutral-500">
        Escanea este código para registrar el dispositivo de comandas.
      </p>
    </div>
  );
}
